<template>
    <div class="cv-stage-progress">
        <!-- Header tóm tắt trạng thái hiện tại -->
        <div class="cv-stage-current" :style="{ borderColor: currentMeta.color, backgroundColor: currentMeta.bg }">
            <div class="cv-stage-current__left">
                <span class="cv-stage-current__icon" :style="{ backgroundColor: currentMeta.color }">
                    <i :class="currentMeta.icon"></i>
                </span>
                <div class="cv-stage-current__info">
                    <div class="cv-stage-current__sub">Tiến trình hiện tại của ứng viên</div>
                    <div class="cv-stage-current__name" :style="{ color: currentMeta.color }">
                        {{ currentMeta.label }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Stepper hành trình toàn bộ các tiến trình/trạng thái -->
        <div class="cv-stepper" ref="stepper">
            <div
                v-for="(stg, idx) in stages"
                :key="stg.key || idx"
                class="cv-step"
                :class="{
                    'cv-step--done': getStageState(stg, idx) === 'done',
                    'cv-step--current': getStageState(stg, idx) === 'current',
                    'cv-step--fail': getStageState(stg, idx) === 'fail',
                    'cv-step--pending': getStageState(stg, idx) === 'pending',
                }"
            >
                <el-tooltip :content="`[#${stg.status}] ${stg.label}`" placement="top" :open-delay="150">
                    <div class="cv-step__node">
                        <div class="cv-step__circle">
                            <i v-if="getStageState(stg, idx) === 'done'" class="el-icon-check"></i>
                            <i v-else-if="getStageState(stg, idx) === 'fail'" class="el-icon-close"></i>
                            <span v-else class="cv-step__num">{{ stg.status }}</span>
                        </div>
                        <div v-if="idx < stages.length - 1" class="cv-step__line"></div>
                    </div>
                </el-tooltip>
                <div class="cv-step__label" :title="`[#${stg.status}] ${stg.label}`">{{ stg.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    CANDIDATE_STAGES,
    getStatusMeta,
} from "@/core/config/recruitmentCvs/recruitmentCvsOption";

export default {
    name: "CvStageProgress",
    props: {
        status: {
            type: [Number, String],
            default: 0,
        },
        visible: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        candidateStatus() {
            return this.status !== undefined && this.status !== null ? Number(this.status) : 0;
        },
        currentMeta() {
            return getStatusMeta(this.candidateStatus);
        },
        stages() {
            return CANDIDATE_STAGES;
        },
        isCurrentFail() {
            return !!this.currentMeta.isFail;
        },
    },
    mounted() {
        this.scrollToActive();
        setTimeout(() => this.scrollToActive(), 80);
        setTimeout(() => this.scrollToActive(), 250);
    },
    watch: {
        status() {
            this.scrollToActive();
            setTimeout(() => this.scrollToActive(), 80);
            setTimeout(() => this.scrollToActive(), 250);
        },
        visible(val) {
            if (val) {
                this.scrollToActive();
                setTimeout(() => this.scrollToActive(), 80);
                setTimeout(() => this.scrollToActive(), 250);
            }
        },
    },
    methods: {
        getStageState(stg) {
            const s = Number(stg.status);
            if (s === this.candidateStatus) {
                return this.isCurrentFail ? "fail" : "current";
            }
            if (s < this.candidateStatus) {
                return "done";
            }
            return "pending";
        },
        scrollToActive() {
            this.$nextTick(() => {
                const stepperEl = this.$refs.stepper;
                if (!stepperEl || stepperEl.clientWidth === 0) return;
                const activeEl = stepperEl.querySelector(".cv-step--current, .cv-step--fail");
                if (activeEl) {
                    const stepperRect = stepperEl.getBoundingClientRect();
                    const activeRect = activeEl.getBoundingClientRect();
                    const offsetDiff = (activeRect.left - stepperRect.left) + stepperEl.scrollLeft;
                    const targetScroll = Math.max(0, offsetDiff - (stepperEl.clientWidth / 2) + (activeEl.clientWidth / 2));
                    stepperEl.scrollLeft = targetScroll;
                }
            });
        },
    },
};
</script>

<style scoped>
.cv-stage-progress {
    margin-bottom: 16px;
}
.cv-stage-current {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid;
    margin-bottom: 14px;
}
.cv-stage-current__left {
    display: flex;
    align-items: center;
    gap: 10px;
}
.cv-stage-current__icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 15px;
    flex-shrink: 0;
}
.cv-stage-current__info {
    display: flex;
    flex-direction: column;
}
.cv-stage-current__sub {
    font-size: 11px;
    color: #64748b;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}
.cv-stage-current__name {
    font-size: 14px;
    font-weight: 800;
    line-height: 1.3;
}
.cv-stepper {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 12px 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
}
.cv-stepper::-webkit-scrollbar {
    height: 6px;
}
.cv-stepper::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}
.cv-stepper::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}
.cv-stepper::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
.cv-step {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 115px;
    width: 115px;
    min-width: 115px;
    padding: 0 4px;
    box-sizing: border-box;
}
.cv-step__node {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 6px;
}
.cv-step__circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 2px solid #cbd5e1;
    color: #64748b;
    font-size: 11.5px;
    font-weight: 700;
    z-index: 2;
    transition: all 0.2s;
}
.cv-step__line {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 2px;
    background: #e2e8f0;
    z-index: 1;
    transform: translateY(-50%);
}
.cv-step__label {
    font-size: 11px;
    color: #64748b;
    text-align: center;
    line-height: 1.35;
    font-weight: 500;
    width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 44px;
}
/* Done state */
.cv-step--done .cv-step__circle {
    background: #059669;
    border-color: #059669;
    color: #fff;
}
.cv-step--done .cv-step__line {
    background: #059669;
}
.cv-step--done .cv-step__label {
    color: #059669;
    font-weight: 600;
}
/* Current active state */
.cv-step--current .cv-step__circle {
    background: #4f46e5;
    border-color: #4f46e5;
    color: #fff;
    box-shadow: 0 0 0 4px #e0e7ff;
}
.cv-step--current .cv-step__label {
    color: #4f46e5;
    font-weight: 700;
}
/* Fail / Rejected state */
.cv-step--fail .cv-step__circle {
    background: #dc2626;
    border-color: #dc2626;
    color: #fff;
    box-shadow: 0 0 0 4px #fee2e2;
}
.cv-step--fail .cv-step__label {
    color: #dc2626;
    font-weight: 700;
}
</style>
